// edit: zhangmyh 2017-6-20 4:36 PM
import './index.less'

export default function boxtips (params) {
  this.tipText = params.tipText || '提示'
  let list = []
  if (params.tipList) {
    if (typeof params.tipList == 'string') {
      list.push(params.tipList)
    } else if (typeof params.tipList == 'function') {
      list.push(params.tipList())
    } else if (typeof params.tipList == 'object') {
      if (params.tipList.length > 0) {
        list = params.tipList
      }
    }
  }
  this.tipList = list
  this.visible = (list.length > 0)
}



// WEBPACK FOOTER //
// ./src/components/box-tips/index.js